<template>
    <div class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>

        <h1 class="view__title title--1" v-html="title_page"/>

        <div class="row ml-0">
            <h6 class="view__title title--1" style="font-size: 13px; font-weight: initial; color: gray;">
                <span>
                    <img src="/assets/img/svg/information.svg" style="width:15px;" alt="info">
                </span>
                <span v-html="'Use this section to search for rooms.'" style="margin-left:5px;"/>
            </h6>
        </div>

        <RoomAdvancedSearch
        ref="advanced_search"
        :checkeable="true"
        :rest_api="'rooms_advanced_search'"
        :rest_api_pagination="'rooms_advanced_search_pagination'"
        @passInitialData="getInitialData($event)"
        :table_headers="table_headers"
        />
        <hr/>
        <div class="row mb-0 ml-0">
            <div style="font-size: 13px; font-weight: initial; color: gray; margin-top: 30px;">
                <span>
                    <img src="/assets/img/svg/information.svg" style="width:15px;" alt="info">
                </span>
                <span v-html="'Use this section to make changes.'" style="margin-left:5px;"/>
            </div>
        </div>

        <form @submit.prevent="form_submit()">
            <div class="row mb-0">
                <div class="formdynamic__item col-md-2 py-0">
                    <div class="formdynamic__item__field">
                        <label class="modal-label" v-html="`Building:`"/>
                        <select class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="form_data.building_id">
                            <option value="" v-html="'Building'"/>
                            <option v-for="(item, i) in array_options.building_id" :key="i" :value="item.id" v-html="`${item.name}`"/>
                        </select>
                    </div>
                </div>
                <div class="formdynamic__item col-md-2 py-0">
                    <div class="formdynamic__item__field">
                        <label class="modal-label" v-html="`Level:`"/>
                        <select class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="form_data.level_id">
                            <option value="" v-html="'Level'"/>
                            <option v-for="(item, i) in array_options.level_id" :key="i" :value="item.id" v-html="`${item.name}`"/>
                        </select>
                    </div>
                </div>
                <div class="formdynamic__item col-md-2 py-0">
                    <div class="formdynamic__item__field">
                        <label class="modal-label" v-html="`Area:`"/>
                        <select class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="form_data.area_id">
                            <option value="" v-html="'Area'"/>
                            <option v-for="(item, i) in array_options.area_id" :key="i" :value="item.id" v-html="`${item.name}`"/>
                        </select>
                    </div>
                </div>
                <div class="formdynamic__item col-md-2 py-0">
                    <div class="formdynamic__item__field">
                        <label class="modal-label" v-html="`Room type:`"/>
                        <select  class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="form_data.room_type_id">
                            <option value="" v-html="'Room type'"/>
                            <option v-for="(item, i) in array_options.room_type_id" :key="i" :value="item.id" v-html="`${item.name}`"/>
                        </select>
                    </div>
                </div>
                <div class="formdynamic__item col-md-2 py-0">
                    <div class="formdynamic__item__field">
                        <label class="modal-label" v-html="`Floor type:`"/>
                        <select  class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="form_data.floor_id">
                            <option value="" v-html="'Floor type'"/>
                            <option v-for="(item, i) in array_options.floor_id" :key="i" :value="item.id" v-html="`${item.name}`"/>
                        </select>
                    </div>
                </div>
                <div class="formdynamic__item col-md-2 py-0">
                    <div class="formdynamic__item__field">
                        <label class="modal-label" v-html="`Cost center:`"/>
                        <select  class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="form_data.cost_center_id">
                            <option value="" v-html="'Cost center'"/>
                            <option v-for="(item, i) in array_options.cost_center_id" :key="i" :value="item.id" v-html="`${item.name}`"/>
                        </select>
                    </div>
                </div>
                <div class="formdynamic__item col-md-2 py-0">
                    <div class="formdynamic__item__field">
                        <label for="Fixtures/Beds:" class="modal-label" v-html="'Fixtures/Beds:'"/>
                        <input type="number" v-model="form_data.fixtures" max="200" step=".01" pattern="\d+"/>
                    </div>
                </div>
                <div class="formdynamic__item col-md-2 py-0">
                    <div class="formdynamic__item__field">
                        <label for="Time adjustment:" class="modal-label" v-html="'Time adjustment:'"/>
                        <input type="number" v-model="form_data.time_adjustment"/>
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0">
                    <div class="formdynamic__item__field">
                        <label for="Closed:" class="modal-label" v-html="'Closed:'"/>
                        <span class="custom-control custom-checkbox">
                            <input :id="'closed-form'" type="checkbox" class="custom-control-input" v-model="form_data.closed"/>
                            <label :for="'closed-form'" class="custom-control-label ml-2"/>
                        </span>
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0">
                    <div class="formdynamic__item__field">
                        <label for="Essential Cleaning:" class="modal-label" v-html="'Essential cleaning:'"/>
                        <span class="custom-control custom-checkbox">
                            <input :id="'essentiel-form'" type="checkbox" class="custom-control-input" v-model="form_data.essential_cleaning"/>
                            <label :for="'essentiel-form'" class="custom-control-label ml-2"/>
                        </span>
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0">
                    <div class="formdynamic__item__field">
                        <label for="Patient:" class="modal-label" v-html="'Patient:'"/>
                        <span class="custom-control custom-checkbox">
                            <input :id="'patient-form'" type="checkbox" class="custom-control-input" v-model="form_data.patient"/>
                            <label :for="'patient-form'" class="custom-control-label ml-2"/>
                        </span>
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0">
                    <div class="formdynamic__item__field">
                        <label for="Work group 2:" class="modal-label" v-html="'Work group 2:'"/>
                        <span class="custom-control custom-checkbox">
                            <input :id="'work-form'" type="checkbox" class="custom-control-input" v-model="form_data.work_group"/>
                            <label :for="'work-form'" class="custom-control-label ml-2"/>
                        </span>
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0">
                    <div class="formdynamic__item__field">
                        <label for="Excl. Dailys" class="modal-label" v-html="'Excl. Dailys:'"/>
                        <span class="custom-control custom-checkbox">
                            <input :id="'exc-daily-form'" type="checkbox" class="custom-control-input" v-model="form_data.exclude_daily"/>
                            <label :for="'exc-daily-form'" class="custom-control-label ml-2"/>
                        </span>
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0">
                    <div class="formdynamic__item__field">
                        <label for="Excl. Projects" class="modal-label" v-html="'Excl. Projects:'"/>
                        <span class="custom-control custom-checkbox">
                            <input :id="'exc-project-form'" type="checkbox" class="custom-control-input" v-model="form_data.exclude_project"/>
                            <label :for="'exc-project-form'" class="custom-control-label ml-2"/>
                        </span>
                    </div>
                </div>

                <div class="formdynamic__item col-md-2 pl-2 py-0">
                    <div class="formdynamic__item__field">
                        <label for="Daily frequency:" class="modal-label" v-html="`Daily frequency:`"/>
                        <input type="number" v-model="form_data.frequency" :min="0" @change="changingDailyTaskFrequency()"/>
                        <!-- <label v-if="calculating_daily_frequency_value">Calculating Frecuency...</label> -->
                    </div>
                </div>
                <div class="formdynamic__item col-md-2 pl-2 py-0">
                    <div class="formdynamic__item__field">
                        <label for="Daily frequency:" class="modal-label" v-html="`Policing frequency:`"/>
                        <input type="number" v-model="form_data.policing_frequency" :min="0"  @change="changingPolicingTaskFrequency()"/>
                        <!-- <label v-if="calculating_policing_frequency_value">Calculating Frecuency...</label> -->
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0">
                    <div class="formdynamic__item__field">
                        <label for="Daily shift:" class="modal-label" v-html="'Daily shift(s):'"/>
                        <span class="d-flex">
                            <div class="pt-2">
                                <label class="modal-label" v-html="'1'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'daily1'" type="checkbox" class="custom-control-input" v-model="form_data.daily_shift_1" @change="updateDailyFrequencyValue()"/>
                                    <label :for="'daily1'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                            <div class="pt-2">
                                <label class="modal-label" v-html="'2'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'daily2'" type="checkbox" class="custom-control-input" v-model="form_data.daily_shift_2" @change="updateDailyFrequencyValue()"/>
                                    <label :for="'daily2'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                            <div class="pt-2">
                                <label class="modal-label" v-html="'3'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'daily3'" type="checkbox" class="custom-control-input" v-model="form_data.daily_shift_3" @change="updateDailyFrequencyValue()"/>
                                    <label :for="'daily3'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0">
                    <div class="formdynamic__item__field">
                        <label for="Policing shift:" class="modal-label" v-html="'Policing shift(s):'"/>
                        <span class="d-flex">
                            <div class="pt-2">
                                <label class="modal-label" v-html="'1'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'policing1'" type="checkbox" class="custom-control-input" v-model="form_data.policing_shift_1" @change="updatePolicingFrequencyValue()"/>
                                    <label :for="'policing1'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                            <div class="pt-2">
                                <label class="modal-label" v-html="'2'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'policing2'" type="checkbox" class="custom-control-input" v-model="form_data.policing_shift_2" @change="updatePolicingFrequencyValue()"/>
                                    <label :for="'policing2'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                            <div class="pt-2">
                                <label class="modal-label" v-html="'3'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'policing3'" type="checkbox" class="custom-control-input" v-model="form_data.policing_shift_3" @change="updatePolicingFrequencyValue()"/>
                                    <label :for="'policing3'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="formdynamic__item col-auto py-0 mb-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Project shift:" class="modal-label" v-html="'Project shift(s): '"/>
                        <span class="d-flex">
                            <div class="pt-2">
                                <label class="modal-label" v-html="'1'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'project1'" type="checkbox" class="custom-control-input" v-model="form_data.project_shift_1"/>
                                    <label :for="'project1'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                            <div class="pt-2">
                                <label class="modal-label" v-html="'2'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'project2'" type="checkbox" class="custom-control-input" v-model="form_data.project_shift_2"/>
                                    <label :for="'project2'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                            <div class="pt-2">
                                <label class="modal-label" v-html="'3'"/>
                                <div class="custom-control custom-checkbox">
                                    <input :id="'project3'" type="checkbox" class="custom-control-input" v-model="form_data.project_shift_3"/>
                                    <label :for="'project3'" class="custom-control-label ml-2"/>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mb-0 assignments">
                <div class="w-100 mt-lg-3">
                    <div class="mx-auto mr-md-0 m2-customable">
                        <button 
                            type="button"
                            class="mx-md-0 modal__buttons__item w-auto ml-sm-2 px-3 ml-md-2"
                            v-html="'View Custom Room Descriptions'"
                            @click="customReportsView()"
                        />
                    </div>
                    <div class="d-inline float-right">
                        <button class="modal__buttons__item w-auto px-3" v-html="'Save changes'"/>
                    </div>
                </div>
            </div>
        </form>

        <FieldsConfirmationModal 
            :title="'Fields massive confirmation'"
            :breadcrumb="breadcrumb"
            :form_data="form_data"
            :notyf="notyf" 
            @formSubmit="form_submit(true)"
            ref="fields_confirmation_modal"
        />
        <HelperModal :helps="helps"/>
        <WaitingModal/>
    </div>
</template>

<script>

import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import RoomAdvancedSearch from '@/components/BuildingComponent/Rooms/AdvancedSearch/RoomAdvancedSearch'
import FieldsConfirmationModal from  '@/components/BuildingComponent/Rooms/MassEditRooms/FieldsConfirmationModal'
import Resources from './resources'
import FormResources from './form_resources'
import WaitingModal from '@/components/WaitingModal'
import HelperModal   from    '@/components/HelperModal'
import Methods from './methods'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})

export default {

    name: 'MassEditRooms',

    components:{
        Breadcrumb,
        WaitingModal,
        RoomAdvancedSearch,
        FieldsConfirmationModal,
        HelperModal
    },

    mixins:[
        Methods,
    ],

    data(){
        return{
            notyf,
            title_page:         'Rooms - Mass Edit Rooms',
            rest_api:           `rooms`,
            child_href:         '/building-room/',
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            form_data:          FormResources.form_data,
            form_backup:        {...FormResources.form_data},
            select_all:         false,
            rooms:              [],
            array_options:      {},
            search:             '',
            helps:              Resources.helps,
            calculating_daily_frequency_value: false,
            calculating_policing_frequency_value: false,
        }
    },

    async mounted()
    {
        if(!this.hasPermissions(['Building-Room Write', 'Building-Room Read']))
        { 
            window.location.href = '/'
        }
    },

}

</script>